<div id="booking-dialog-container">
  <!-- Header -->
  <div class="flex-end">
    <!-- <div class="title margin-right-1">{{ '' | translate }}</div> -->
    <button mat-icon-button color="warn" (click)="closeDialog()">
      <mat-icon svgIcon="close-circle"></mat-icon>
    </button>
  </div>
  <div class="mat-h4">
    {{ "select-hour-start" | translate }}
  </div>
  <form [formGroup]="form" (ngSubmit)="sendForm()">
    <mat-form-field appearance="legacy" class="margin-top-1">
      <mat-label>{{ "start" | translate }}</mat-label>
      <mat-select formControlName="start">
        <mat-option [value]="option.date" *ngFor="let option of options"
          >{{ option.str }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.errors">
        {{ "valid-input" | translate }}
      </mat-error>
    </mat-form-field>

    <div class="margin-top-05">{{ "end" | translate }}: {{ end }}</div>


    <button
      mat-raised-button
      color="primary"
      class="width-100 margin-top-1 margin-bottom-05"
      [disabled]="form.invalid"
      type="submit"
    >
      <span>{{ "select" | translate }}</span>
    </button>
  </form>
</div>
